export const qtyEnter = () => {
  $('#quantityInput').on('keydown', function(event){
    if (event.keyCode == 13) {
      $("#add-to-bag").trigger("click");
      return false;
    }
  });
}
